import { render, staticRenderFns } from "./DownloadView.vue?vue&type=template&id=0d3bd594&scoped=true"
import script from "./DownloadView.vue?vue&type=script&lang=js"
export * from "./DownloadView.vue?vue&type=script&lang=js"
import style0 from "./DownloadView.vue?vue&type=style&index=0&id=0d3bd594&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3bd594",
  null
  
)

export default component.exports